import { useContext, useEffect, useState, useRef } from "react"
import CheckoutHeader from "../../Component/Header/checkoutheader"
import DataContext from "../../Component/context"
import { ApiService } from "../../Component/services/apiServices"
import { toast } from 'react-toastify'
import sessionCartData from "../../Component/Element/cart_session_data"
import { useNavigate, useLocation } from "react-router-dom"
import { checkOrderProcess } from "../../Component/check_order_process"
import { sendConversionEvent } from "../../Component/utils/gtag"
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import ApplePayButton from "./ApplePayButton"

const Payment = () => {
    const stripePromise = loadStripe("pk_test_51O2wexGW90RgCCO5VSGgHkI7ypkZS2XIWNSBPl9Jhxwd1cUs8Pgd17KC3NOYpFxB7t4q4UVCKFK31pxTQvjv7Fxq00avBKCbXZ");
    const dataArray = sessionCartData()
    const navigate = useNavigate()
    const location = useLocation();
    const { state } = location || {};
    const cartSummary = dataArray[3]
    const contextValues = useContext(DataContext)
    const isOrderStop = contextValues?.settingData?.order_stop == 1 || contextValues?.settingData?.order_stop === true;
    const isSettingLoaded = Object.keys(contextValues?.settingData || {}).length > 0;
    const didMountRef = useRef(true);
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [walletBalance, setWalletBalance] = useState(0)
    const [finalAmount, setFinalAmount] = useState(0)
    const [paymentMode, setPaymentMode] = useState("newcard")
    const [savedCardList, setSavedCardList] = useState([])
    const [newCardState, setNewCardState] = useState({
        ucd_id: 0,
        number: "",
        name: "",
        expiry: "",
        cvc: "",
        focus: "",
        save_card: 0
    });

    const cardImage = (type) => {
        switch (type) {
            case 'Visa':
                return ('/img/vcard.png');
            case 'MasterCard':
                return ('/img/mcard.png');
            case 'American Express':
                return ('/img/amex.png');
            case 'Discover':
                return ('/img/dcard.png');
            case 'atm':
                return ('/img/atmcards.png');
            case 'JCB':
                return ('/img/jcard.png');
            default:
                return ('/img/ucard.png');
        }
    }

    useEffect(() => {
        if (didMountRef.current) {
            const sessionSelectedAddress = JSON.parse(localStorage.getItem("SELECTED_ADDRESS"));
            if (sessionSelectedAddress) {
                contextValues.setSelectedAddress(sessionSelectedAddress);
            }
            const sessionSelectedCoupon = JSON.parse(localStorage.getItem("COUPON_SESSION"));
            if (sessionSelectedCoupon) {
                contextValues.setSelectedCoupon(sessionSelectedCoupon);
            }
            ApiService.fetchData("user-savedc-cards").then((res) => {
                if (res?.status === "success") {
                    setSavedCardList(res.cards)
                }
            })

            ApiService.fetchData("wallet-balance").then((res) => {
                if (res?.status === "success") {
                    setWalletBalance(res.wallet_balance)
                }
            })
            let shippingCharge = 0;
            let couponCharge = 0;
            if (contextValues.orderRecieveStatus === 'delivery') {
                shippingCharge = parseFloat(state.shippingAmount || 0);
            }

            if (contextValues.selectedCoupon?.promo_id > 0) {
                couponCharge = parseFloat(contextValues.selectedCoupon?.discount_amount || 0);
            }

            const finalAmount = parseFloat(cartSummary?.total_amount || 0) + shippingCharge - couponCharge;
            setFinalAmount(finalAmount)
        }
        didMountRef.current = false;

    }, [newCardState]);


    const changePaymanetMode = (mode) => {
        setPaymentMode(mode)
        setNewCardState((prevCardState) => ({
            ...prevCardState,
            ucd_id: 0,
        }));
    }

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        let updatedValue = type === 'checkbox' ? (checked ? 1 : 0) : value;
        if (name === 'number') {
            const numberWithoutSpaces = value.replace(/\s/g, '');
            updatedValue = numberWithoutSpaces.replace(/\D/g, '');
            updatedValue = updatedValue.replace(/[^\d]/g, '');
            updatedValue = updatedValue.replace(/(.{4})/g, '$1 ').trim();
            if (updatedValue.length > 20) {
                return false;
            }
        } else if (name === 'expiry') {
            updatedValue = value.replace(/[^\d\/]/g, '');
            if (updatedValue.length === 2 && !updatedValue.includes('/')) {
                updatedValue += '/';
            }
            if (updatedValue.length > 5) {
                return false;
            }
        } else if (name === 'cvc') {
            const numberWithoutSpaces = value.replace(/\s/g, '');
            updatedValue = numberWithoutSpaces.replace(/\D/g, '');
            updatedValue = updatedValue.replace(/[^\d]/g, '');
            updatedValue = updatedValue.replace(/(.{4})/g, '$1 ').trim();
            if (updatedValue.length > 4) {
                return false;
            }
        }
        setNewCardState({
            ...newCardState,
            [name]: updatedValue
        });
    };

    const selectedCardDetail = (ucdId) => {
        setNewCardState((prevCardState) => ({
            ...prevCardState,
            ucd_id: ucdId,
            cvc: '',
        }));
        if (ucdId > 0) {
            setPaymentMode("savedcard");
        } else {
            setPaymentMode("newcard");
        }

    }

    const handleSavedCard = (e, item) => {
        const { name, value } = e.target;
        let updatedValue = value;

        if (name === "cvc") {
            if (updatedValue.length > 3) {
                toast.error("CVC number cannot exceed 3 digits");
                return;
            }

            if (updatedValue.length === 3) {
                setNewCardState((prevCardState) => ({
                    ...prevCardState,
                    ucd_id: item.ucd_id,
                    cvc: updatedValue,
                    save_card: 1,
                }));
            } else {
                setNewCardState((prevCardState) => ({
                    ...prevCardState,
                    cvc: updatedValue,
                }));
            }
        }
    };


    const proceedToPayByWallet = async () => {
        const validation = await checkOrderProcess(contextValues);
        if (validation) {
            let shippingCharge = 0;
            let couponCharge = 0;

            if (contextValues.orderRecieveStatus === 'delivery') {
                shippingCharge = parseFloat(state.shippingAmount || 0);
            }

            if (contextValues.selectedCoupon?.promo_id > 0) {
                couponCharge = parseFloat(contextValues.selectedCoupon?.discount_amount || 0);
            }

            const finalAmount =
                parseFloat(cartSummary?.total_amount || 0) + shippingCharge - couponCharge;
            const walletbalance = walletBalance
            if (walletbalance < finalAmount) {
                toast.error("Insufficient Balance , Please add Money to Wallet for Payment with wallet")
                return false;
            } else {
                const dataString = {
                    cart_session_data: contextValues.cartSessionData,
                    store_data: state.store,
                    coupon_session_data: contextValues.selectedCoupon,
                    cart_summary_data: cartSummary,
                    address_session: contextValues.selectedAddress,
                    trans_payment: finalAmount.toFixed(2),
                    ua_id: contextValues.orderRecieveStatus === 'delivery' ? contextValues.selectedAddress.ua_id : 0,
                    trans_payment_method: 'wallet',
                    delivery_type: contextValues.orderRecieveStatus === 'delivery' ? 1 : 0,
                    trans_shipping_amount: shippingCharge,
                    total_discount_amount: parseFloat(cartSummary.discount),
                    order_note: state.order_note,
                    trans_order_on: 'MOBILE',
                }
                setSpinnerLoading(true)
                ApiService.postData('create-wallet-transaction', dataString).then((res) => {
                    if (res.status === 'success') {
                        sendConversionEvent(res.orderid, finalAmount);
                        localStorage.removeItem("ADDRESS_SESSION");
                        localStorage.removeItem("COUPON_SESSION");
                        localStorage.removeItem("CART_SESSION");
                        setSpinnerLoading(false)
                        navigate('/thankyou/' + res.orderid)
                    } else {
                        setSpinnerLoading(false)
                        toast.error(res.message)
                    }
                })
            }
        }
    }

    const proceedToPayBySavedCard = async () => {
        const validation = await checkOrderProcess(contextValues);
        if (validation) {
            if (newCardState.cvc.length !== 3) {
                toast.error('Please enter valid cvc')
                return false;
            }
            setSpinnerLoading(true)
            let shippingCharge = 0;
            let couponCharge = 0;

            if (contextValues.orderRecieveStatus === 'delivery') {
                shippingCharge = parseFloat(state.shippingAmount || 0);
            }

            if (contextValues.selectedCoupon?.promo_id > 0) {
                couponCharge = parseFloat(contextValues.selectedCoupon?.discount_amount || 0);
            }

            const finalAmount = parseFloat(cartSummary?.total_amount || 0) + shippingCharge - couponCharge;
            const dataString = {
                cart_session_data: contextValues.cartSessionData,
                store_data: state.store,
                coupon_session_data: contextValues.selectedCoupon,
                cart_summary_data: cartSummary,
                address_session: contextValues.selectedAddress,
                trans_payment: finalAmount,
                ua_id: contextValues.orderRecieveStatus === 'delivery' ? contextValues.selectedAddress.ua_id : 0,
                delivery_type: contextValues.orderRecieveStatus === 'delivery' ? 1 : 0,
                trans_shipping_amount: shippingCharge,
                total_discount_amount: parseFloat(cartSummary.discount),
                order_note: state.order_note,
                cvc: newCardState.cvc,
                save_card: newCardState.save_card,
                ucd_id: newCardState.ucd_id,
                trans_payment_method: 'card',
                trans_order_on: 'MOBILE',
            }

            ApiService.postData('create-card-token-new', dataString).then((res) => {
                if (res.status === 'success') {
                    sendConversionEvent(res.orderid, finalAmount);
                    localStorage.removeItem("ADDRESS_SESSION");
                    localStorage.removeItem("COUPON_SESSION");
                    localStorage.removeItem("CART_SESSION");
                    setSpinnerLoading(false)
                    navigate('/thankyou/' + res.orderid)
                } else {
                    setSpinnerLoading(false)
                    toast.error(res.message)
                }
            })
        }
    }

    const proceedToPayByNewCard = async () => {
        const validation = await checkOrderProcess(contextValues);
        if (validation) {
            if (newCardState.number === '') {
                toast.error('Please enter card number')
                return false;
            } else if (newCardState.number.length > 19 || newCardState.number.length < 19) {
                toast.error('Please enter valid card details')
                return false;
            }

            if (newCardState.expiry === '') {
                toast.error('Please enter name')
                return false;
            }

            const currentDate = new Date();
            const currentYear = currentDate.getFullYear() % 100;
            const currentMonth = currentDate.getMonth() + 1;
            const [inputMonth, inputYear] = newCardState.expiry.split('/').map(Number);
            const isValidDate = inputYear > currentYear || (inputYear === currentYear && inputMonth <= currentMonth);
            if (!isValidDate) {
                toast.error('Please enter valid expiry')
                return false;
            }

            if (newCardState.cvc.length !== 3) {
                toast.error('Please enter valid cvc')
                return false;
            }
            setSpinnerLoading(true)
            let shippingCharge = 0;
            let couponCharge = 0;

            if (contextValues.orderRecieveStatus === 'delivery') {
                shippingCharge = parseFloat(state.shippingAmount || 0);
            }

            if (contextValues.selectedCoupon?.promo_id > 0) {
                couponCharge = parseFloat(contextValues.selectedCoupon?.discount_amount || 0);
            }
            const finalAmount = parseFloat(cartSummary?.total_amount || 0) + shippingCharge - couponCharge;
            const dataString = {
                cart_session_data: contextValues.cartSessionData,
                store_data: state.store,
                coupon_session_data: contextValues.selectedCoupon,
                cart_summary_data: cartSummary,
                address_session: contextValues.selectedAddress,
                trans_payment: finalAmount,

                ua_id: contextValues.orderRecieveStatus === 'delivery' ? contextValues.selectedAddress.ua_id : 0,
                trans_payment_method: 'card',
                delivery_type: contextValues.orderRecieveStatus === 'delivery' ? 1 : 0,
                trans_shipping_amount: shippingCharge,
                total_discount_amount: parseFloat(cartSummary.discount),
                order_note: state.order_note,

                card_number: Number(newCardState.number.replace(/\s/g, '')),
                exp_month: inputMonth,
                exp_year: inputYear,
                cvc: newCardState.cvc,
                name: newCardState.name,
                save_card: newCardState.save_card,
                ucd_id: 0,
                trans_order_on: 'MOBILE'
            }

            ApiService.postData('create-card-token-new', dataString).then((res) => {
                if (res.status === 'success') {
                    sendConversionEvent(res.orderid, finalAmount);
                    localStorage.removeItem("ADDRESS_SESSION");
                    localStorage.removeItem("COUPON_SESSION");
                    localStorage.removeItem("CART_SESSION");
                    localStorage.removeItem("RECENTLY_VIEWED");
                    setSpinnerLoading(false)
                    navigate('/thankyou/' + res.orderid)
                } else {
                    setSpinnerLoading(false)
                    toast.error(res.message)
                }
            })
        }
    }
    return (
        <>
            <CheckoutHeader heading={'Payment'} step={'3'} />
            <div id="appCapsule">
                {contextValues.cartCount > 0 ?
                    <>
                        <div className="checkbox mb-15">
                            <h6>Select Payment Method</h6>
                            <div className={`cardwallet ${paymentMode === "wallet" ? "active" : ""}`} onClick={() => changePaymanetMode('wallet')}>
                                <div className="cardwallet-price">${walletBalance}</div>
                                <div>
                                    <h6 className="mb-0 tx-14">Pay Using Wallet</h6>
                                    <p className="mb-0 tx-12">Pay your order using wallet</p>
                                </div>
                                {paymentMode === "wallet" &&
                                    <div className="cardselectleft">
                                        <img src="/img/correct.png" className="cardsaveboxarrow" alt="Daadi's Kitchen"></img>
                                    </div>
                                }
                            </div>
                            <div className="cardselect-inner" >
                                <div className={`cardselectbox ${paymentMode === "card" || paymentMode === "savedcard" || paymentMode === "newcard" ? "active" : ""}`} onClick={() => changePaymanetMode('newcard')}>
                                    <ul>
                                        <li><img alt="Daadi's Kitchen" src="/img/visa.svg" height={38}></img></li>
                                        <li><img alt="Daadi's Kitchen" src="/img/master.svg" height={38}></img></li>
                                        <li><img alt="Daadi's Kitchen" src="/img/amex.svg" height={38}></img></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {paymentMode === "card" || paymentMode === "savedcard" || paymentMode === "newcard" ?
                            <div className="checkbox mb-15">
                                {savedCardList && savedCardList.length > 0 ?
                                    <>
                                        {savedCardList.map((items, index) => {
                                            return (
                                                <div className="cardsavebox" key={index}>
                                                    <div className={Number(newCardState.ucd_id) === Number(items.ucd_id) ? "cardsaveboxnu active" : "cardsaveboxnu"} onClick={(e) => selectedCardDetail(items.ucd_id)}>
                                                        <div className="cardsavebox-icon">
                                                            <img alt="Daadi's Kitchen" src={cardImage(items?.ucd_card_type)} style={{ width: "40px", marginTop: "7px" }}></img>
                                                        </div>
                                                        <div className="cardsavebox-number">Ending with {items?.ucd_four_number}</div>
                                                        <img alt="Daadi's Kitchen" src="/img/correct.png" className="cardsaveboxselect"></img>
                                                    </div>
                                                    {Number(newCardState.ucd_id) === Number(items.ucd_id) &&
                                                        <div className="row mt-3">
                                                            <div className="col-lg-12 ">
                                                                <div className="crdform">
                                                                    <label>CVC</label>
                                                                </div>
                                                                <div className="crdform">
                                                                    <input type="number" name="cvc"
                                                                        placeholder="CVC"
                                                                        pattern="\d{3,4}"
                                                                        value={newCardState?.cvc}
                                                                        onChange={(e) => { handleSavedCard(e, items) }}
                                                                        required></input>
                                                                    <div className="cicon"><img alt="Daadi's Kitchen" src="/img/cvv.svg" height={45} style={{ borderRadius: '4px' }}></img></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            )
                                        })}
                                        <div className="cardsavebox">
                                            <div className={Number(newCardState.ucd_id) === 0 ? "cardsaveboxnu active" : "cardsaveboxnu"} onClick={(e) => selectedCardDetail(0)}>
                                                <div className="cardsavebox-icon">
                                                    <img alt="Daadi's Kitchen" src="/img/atmcards.png" style={{ width: "40px", marginTop: "7px" }}></img>
                                                </div>
                                                <div className="cardsavebox-number">Use a different card</div>
                                                <img alt="Daadi's Kitchen" src="/img/correct.png" className="cardsaveboxselect"></img>
                                            </div>
                                            {Number(newCardState.ucd_id) === 0 &&
                                                <div className="carddetal mt-3">
                                                    <div className="row">
                                                        <div className="col-lg-12 ">
                                                            <div className="crdform">
                                                                <label>Card Number</label>
                                                            </div>
                                                            <div className="crdform  mb-3">
                                                                <input type="text"
                                                                    name="number"
                                                                    placeholder="Card Number"
                                                                    value={newCardState.number}
                                                                    onChange={(e) => handleInputChange(e)}
                                                                ></input>
                                                                <div className="cicon"><img alt="Daadi's Kitchen" src="/img/cradicon.svg" height={45} style={{ borderRadius: '4px' }}></img></div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="crdform">
                                                                <label>Valid Thru</label>
                                                            </div>
                                                            <div className="crdform mb-3">
                                                                <input type="text"
                                                                    name="expiry"
                                                                    placeholder="Valid Thru"
                                                                    pattern="\d\d/\d\d"
                                                                    value={newCardState.expiry}
                                                                    onChange={(e) => handleInputChange(e)}
                                                                ></input>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="crdform">
                                                                <label>CVC</label>
                                                            </div>
                                                            <div className="crdform  mb-3">
                                                                <input type="text"
                                                                    name="cvc"
                                                                    placeholder="CVC"
                                                                    pattern="\d{3,4}"
                                                                    value={newCardState.cvc}
                                                                    onChange={(e) => handleInputChange(e)}
                                                                ></input>
                                                                <div className="cicon"><img alt="Daadi's Kitchen" src="/img/cvv.svg" height={45} style={{ borderRadius: '4px' }}></img></div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="crdform checkboxinput mb-3">
                                                                <input type="checkbox" name="save_card" value="1" onChange={(e) => { handleInputChange(e) }}></input>
                                                                Save card for next time
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </>
                                    :
                                    <div className="carddetal">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="crdform">
                                                    <label>Card Number</label>
                                                </div>
                                                <div className="crdform  mb-3">
                                                    <input type="text"
                                                        name="number"
                                                        placeholder="Card Number"
                                                        value={newCardState.number}
                                                        onChange={(e) => handleInputChange(e)}
                                                    ></input>
                                                    <div className="cicon"><img alt="Daadi's Kitchen" src="/img/cradicon.svg" height={45} style={{ borderRadius: '4px' }}></img></div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="crdform">
                                                    <label>Expiry date</label>
                                                </div>
                                                <div className="crdform mb-3">

                                                    <input type="text"
                                                        name="expiry"
                                                        placeholder="Valid Thru"
                                                        pattern="\d\d/\d\d"
                                                        value={newCardState.expiry}
                                                        onChange={(e) => handleInputChange(e)}
                                                    ></input>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="crdform">
                                                    <label>CVV</label>
                                                </div>
                                                <div className="crdform mb-3">

                                                    <input type="text"
                                                        name="cvc"
                                                        placeholder="CVC"
                                                        pattern="\d{3,4}"
                                                        value={newCardState.cvc}
                                                        onChange={(e) => handleInputChange(e)}
                                                    ></input>
                                                    <div className="cicon"><img alt="Daadi's Kitchen" src="/img/cvv.svg" height={45} style={{ borderRadius: '4px' }}></img></div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="crdform checkboxinput mb-3">
                                                    <input type="checkbox" name="save_card" value="1" onChange={(e) => { handleInputChange(e) }}></input>
                                                    Save card for next time
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div> :
                            <>
                            </>
                        }
                        <div className="checkout-footer p-0">
                            <div className="p-15">
                                {!isSettingLoaded ? (<button type="button" className="btn btn-primary btn-lg btn-full" disabled><img loading="lazy" src="/img/loder01.gif" width="60px" height="11px" /></button>) : isOrderStop ? (<div className="alert alert-warning text-center mb-0" role="alert" style={{ whiteSpace: 'pre-line' }}>{contextValues?.settingData?.order_stop_message || 'We are not accepting orders at the moment.'}</div>) : (<>
                                    <ApplePayButton amount={finalAmount} />
                                    {spinnerLoading ?
                                        <button type="button" className="btn btn-primary btn-lg btn-full" disabled={spinnerLoading}><img loading="lazy" src="/img/loder01.gif" width="60px" height="11px" /></button> :
                                        paymentMode === "newcard" ?
                                            <button type="button" className="btn btn-primary btn-lg btn-full" disabled={spinnerLoading} onClick={(e) => proceedToPayByNewCard()}>Proceed To Payment (${(() => {
                                                let shippingCharge = 0;
                                                let couponCharge = 0;

                                                if (contextValues.orderRecieveStatus === 'delivery') {
                                                    shippingCharge = parseFloat(state?.shippingAmount || 0);
                                                }

                                                if (contextValues.selectedCoupon?.promo_id > 0) {
                                                    couponCharge = parseFloat(contextValues.selectedCoupon?.discount_amount || 0);
                                                }

                                                const finalAmount = parseFloat(cartSummary?.total_amount || 0) + shippingCharge - couponCharge;

                                                return finalAmount.toFixed(2);
                                            })()})
                                            </button>
                                            :
                                            paymentMode === "savedcard" ?
                                                <button type="button" className="btn btn-primary btn-lg btn-full" disabled={spinnerLoading} onClick={(e) => proceedToPayBySavedCard()}> Proceed To Payment (${(() => {
                                                    let shippingCharge = 0;
                                                    let couponCharge = 0;

                                                    if (contextValues.orderRecieveStatus === 'delivery') {
                                                        shippingCharge = parseFloat(state?.shippingAmount || 0);
                                                    }

                                                    if (contextValues.selectedCoupon?.promo_id > 0) {
                                                        couponCharge = parseFloat(contextValues.selectedCoupon?.discount_amount || 0);
                                                    }

                                                    const finalAmount = parseFloat(cartSummary?.total_amount || 0) + shippingCharge - couponCharge;

                                                    return finalAmount.toFixed(2);
                                                })()})
                                                </button>
                                                :
                                                <button type="button" className="btn btn-primary btn-lg btn-full" disabled={spinnerLoading} onClick={(e) => proceedToPayByWallet()}>Proceed To Payment (${(() => {
                                                    let shippingCharge = 0;
                                                    let couponCharge = 0;

                                                    if (contextValues.orderRecieveStatus === 'delivery') {
                                                        shippingCharge = parseFloat(state?.shippingAmount || 0);
                                                    }

                                                    if (contextValues.selectedCoupon?.promo_id > 0) {
                                                        couponCharge = parseFloat(contextValues.selectedCoupon?.discount_amount || 0);
                                                    }

                                                    const finalAmount =
                                                        parseFloat(cartSummary?.total_amount || 0) + shippingCharge - couponCharge;

                                                    return finalAmount.toFixed(2);
                                                })()})
                                                </button>
                                    }
                                </>)}

                            </div>
                        </div>
                    </>
                    :
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className='noimg text-center mt-5'>
                                    <img src='/img/emptycart.png' className='wd-150' alt="Daadi's Kitchen" ></img>
                                    <h5>Your Cart is Empty</h5>
                                    <p>It looks like you haven't added any items to your cart yet.Your cart is waiting for items!</p>
                                    <a href='/' className='btn btn-outline-primary btn-md'>Continue Order</a>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}
export default Payment